import axios from "axios";

let storeRef = null;

export const injectPersonaliseStore = (store) => {
  storeRef = store;
};

export const axiosAuth = axios.create({});
export const axiosNoAuth = axios.create({});
export const axiosXanoAuth = axios.create({});

axiosAuth.interceptors.request.use((config) => {
  const token = storeRef?.getState()?.personaliseLessons?.authentication?.token;
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});
